import { property, supertypeClass } from '@haventech/amorphic';
import { CasApplication } from './CasApplication';
import { CoverpathCustomer } from './CoverpathCustomer';
import { CoverpathAnnuity } from './CoverpathAnnuity';

@supertypeClass({ toClient: true, toServer: true })
export class CoverpathAnnuityApplication extends CasApplication {
  @property({
    comment: 'The ID of the Questionnaire Service application form linked to this application',
    toServer: false,
  })
  applicationFormQsID: string;

  static new(customer: CoverpathCustomer) {
    return new CoverpathAnnuityApplication().init(customer);
  }

  constructor() {
    super();
  }

  public getApplicationType() {
    return CoverpathAnnuityApplication;
  }

  get annuity() {
    return this.primaryPolicy as CoverpathAnnuity;
  }

  retrieveApplicant() {
    // NOT needed - this gets called when workflow is started (through Controller.refreshPolicy function)
  }

  retrievePersonalHistory() {
    // NOT needed - this gets called when we have stale data in the object graph (through Controller.preServerCall function)
    return null;
  }
}
